// src/app/translation.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TranslationService {
  private apiUrl = "https://translation.googleapis.com/language/translate/v2";
  private apiKey = "AIzaSyBVIZu9ASJitQ6wj8TOca7-zPrLoQWoxAk";
  url: string;

  constructor(private http: HttpClient) {}

  translate(text: string, targetLang: string,sourceLang: string) {
    const url = `${this.apiUrl}?key=${this.apiKey}`;
    const body = {
      q: [text],
      target: targetLang,
      source: sourceLang

    };
    return this.http.post(url, body);
  }

  //   translate(
  //     text: string,
  //     targetLang: string,
  //     sourceLang: string
  //   ): Observable<any> {
  //     const body = {
  //       q: [text],
  //       target: "es",
  //       source: "en",
  //     };
  //     return this.http.post(this.url, body);
  //   }
}
